import store from '@/store';
import Vue from 'vue';
import logError from '@/utils/logError/logError';
import { getAppPermissions, isImpersonationBlocked } from './utils/appRouteData';

const routes = [
  {
    path: '/embedded/:appName',
    name: 'embeddedApp',
    component: () => import(/* webpackChunkName: "EmbeddedApp" */ './views/LiveEmbeddedAppsPage.vue'),
    props: (route) => ({
      featureFlag: 'embedded_app_deep_link_pov',
      angularRoute: 'app.embedded',
      query: route.query,
      ...route.params,
    }),
    children: [{
      path: ':page',
      name: 'embeddedAppRoute',
      component: () => import(/* webpackChunkName: "EmbeddedApp" */ './views/LiveEmbeddedAppsPage.vue'),
      props: (route) => ({
        featureFlag: 'embedded_app_deep_link_pov',
        angularRoute: 'app.embedded',
        query: route.query,
        ...route.params,
      }),
    }],
    beforeEnter: async (to, from, next) => {
      await store.dispatch('MainMenuStore/fetchApplicationsMenuItems');
      const externalApps = store.getters['MainMenuStore/externalApplications'];
      const currentApp = externalApps.find((item) => item.app_code_name === to.params.appName);

      let hasPermissions = true;
      const routePermissions = getAppPermissions(currentApp, to.params.page);

      if (routePermissions) {
        const newPermissions = routePermissions.filter((item) => item.indexOf('.') !== -1);

        if (newPermissions.length > 0) {
          try {
            const permissionResults = await Vue.prototype.$hasPermissionsAsync(newPermissions);
            hasPermissions = Object.values(permissionResults).every((item) => !!item);
          } catch (error) {
            logError('Error while getting permissions', error, newPermissions);
          }
        }
      }

      // Check if impersonated session is allowed for this app
      const blockImpersonation = isImpersonationBlocked(currentApp, to.params.page);
      const isImpersonationValid = !(store.getters['AuthStore/isImpersonating'] && blockImpersonation);

      if (hasPermissions && isImpersonationValid) {
        next();
      } else {
        next({ name: 'userError', params: { errorType: 'unauthorised' } });
      }
    },
  },
];

export default routes;
